import { Component, JSX, Prop, h } from '@stencil/core'

@Component({
  tag: 'air-icon',
  styleUrl: 'air-icon.scss',
  shadow: true,
})
export class AirIcon {
  /** Defines the icon name */
  @Prop() name?: string

  render(): JSX.Element {
    const classes = {
      icon: true,
      [`icon-${this.name}`]: this.name !== undefined,
    }
    const styles = {
      '--air-icon': `var(--air-icon-${this.name})`,
    }
    const attributes = {
      class: classes,
      style: styles,
    }
    return <div {...attributes}></div>
  }
}
